<template>
  <div class="GoodsItem2">
    <van-image fit="cover" class="pic" src="" error-icon="photo" />
    <div class="rightPart">
        <van-skeleton title :row="2" class="mySkeleton" />
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
import { Skeleton } from "vant";
export default {
  data() {
    return {};
  },
  components: {
    VanImage,
    "van-skeleton": Skeleton,
  },
};
</script>

<style scoped lang="scss">
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.GoodsItem2 {
  display: flex;
  flex-direction: column;
  width: vw(175);
  // height: vw(135);
  margin-bottom: vw(20);
  border-radius: vw(5);
  background-color: #fff;
  .pic {
    width: vw(175);
    height: vw(175);
  }
  .rightPart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    height: 100%;
    padding: vw(8);
  }
  .mySkeleton {
    padding: 0;
  }
}
</style>
